import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/loading.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title-4 text-center" }, "Justificatif fiscal", -1)
const _hoisted_2 = {
  key: 0,
  class: "errors"
}
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, " Ne prend en compte que les fiches avec TOUTES ces conditions: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", { class: "block list-style ps-2" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Date de la fiche >= 09/06/22"),
  /*#__PURE__*/_createElementVNode("li", null, " Case \"Bénéficier de la déduction des frais kilométriques cochée "),
  /*#__PURE__*/_createElementVNode("li", null, "Nom et prénom du demandeur/témoin saisis"),
  /*#__PURE__*/_createElementVNode("li", null, "Puissance fiscale du véhicule saisie"),
  /*#__PURE__*/_createElementVNode("li", null, "Adresse du demandeur/témoin saisie"),
  /*#__PURE__*/_createElementVNode("li", null, "Téléphone du demandeur/témoin saisi"),
  /*#__PURE__*/_createElementVNode("li", null, "Commune du demandeur/témoin saisie"),
  /*#__PURE__*/_createElementVNode("li", null, "Code postal de la commune d'intervention saisi")
], -1)
const _hoisted_6 = { class: "form-content mt-1" }
const _hoisted_7 = { class: "form-fields" }
const _hoisted_8 = { class: "field form-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "field-header" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "km-report-year" }, "Année concernée")
], -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "btn btn-primary mt-1",
  type: "submit"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Télécharger ")
const _hoisted_13 = {
  key: 1,
  class: "spinner"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "Spinner"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

import { request } from "@/domains/api/api";
import { useLoading } from "@/domains/app/loading";
import { useUser } from "@/domains/auth/user";
import { computed, ref } from "vue";
import { downloadDocument } from "../exports";
import Modal from "@/domains/app/components/Modal.vue";
import Form from "@/domains/app/components/Form.vue";
import { FormErrors, FormParams, createFieldState } from "@/domains/app/forms";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { loading, setLoading } = useLoading("km-report");
const { user } = useUser();

const now = new Date();
const kmReportError = ref<string | null>(null);
const kmReportDetails = ref({
    adress: "",
    zip_code: "",
    city: "",
    year: now.getFullYear(),
});
const showPrompModal = ref(false);

const bounds = computed(() => {
    const start =
        kmReportDetails.value.year === 2023
            ? "09/06/22"
            : "01/01/" + (kmReportDetails.value.year - 1);
    const end = "31/12/" + (kmReportDetails.value.year - 1);
    return { start, end };
});

const detailsErrors = ref<FormErrors | null>(null);
const formProps: FormParams = {
    title: "Informations personnelles",
    driver: {},
    getErrors: () => detailsErrors,
    fields: [
        {
            name: "adress",
            label: "Adresse",
            type: "text",
            getState: () => createFieldState<string>(kmReportDetails, "adress"),
            markAsRequired: true,
        },
        {
            name: "zip_code",
            label: "Code postal",
            type: "text",
            getState: () =>
                createFieldState<string>(kmReportDetails, "zip_code"),
            markAsRequired: true,
        },
        {
            name: "city",
            label: "Ville",
            type: "text",
            getState: () => createFieldState<string>(kmReportDetails, "city"),
            markAsRequired: true,
        },
    ],
};

function submitDetails() {
    const errors: Record<string, string[]> = {};
    if (!kmReportDetails.value.adress) {
        errors.adress = ["Champs obligatoire"];
    }
    if (!kmReportDetails.value.zip_code) {
        errors.zip_code = ["Champs obligatoire"];
    }
    if (!kmReportDetails.value.city) {
        errors.city = ["Champs obligatoire"];
    }

    if (Object.keys(errors).length) {
        detailsErrors.value = { message: "", fields: errors };
        return;
    }

    downloadKMReport();
}

function downloadKMReport() {
    kmReportError.value = null;
    if (!user.value || loading.value) return;
    setLoading(true);

    request<string>("exports/km-report", "get", () => null, {
        user_id: user.value.id,
        ...kmReportDetails.value,
        year: kmReportDetails.value.year,
    })
        .then((rs) => {
            if (!rs) return (kmReportError.value = "Aucune donnée trouvée");
            downloadDocument(
                "justificatif-" + kmReportDetails.value.year + ".pdf",
                rs
            );
        })
        .catch(
            (rs) =>
                (kmReportError.value =
                    rs?.response?.data?.error ?? "Une erreur est survenue")
        )
        .finally(() => {
            setLoading(false);
            showPrompModal.value = false;
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "form mb-1",
      action: "",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showPrompModal.value = true), ["prevent"]))
    }, [
      _hoisted_1,
      (kmReportError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(kmReportError.value), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, " Concernant les kilomètres effectués en voiture des fiches entre le " + _toDisplayString(_unref(bounds).start) + " et le " + _toDisplayString(_unref(bounds).end) + ". ", 1),
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              name: "km-report-year",
              id: "km-report-year",
              class: "field__widget",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((kmReportDetails.value.year) = $event))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  (_unref(now).getFullYear() - i + 1 >= 2023)
                    ? (_openBlock(), _createElementBlock("option", {
                        key: 0,
                        value: _unref(now).getFullYear() - i + 1
                      }, _toDisplayString(_unref(now).getFullYear() - i + 1), 9, _hoisted_10))
                    : _createCommentVNode("", true)
                ], 64))
              }), 64))
            ], 512), [
              [_vModelSelect, kmReportDetails.value.year]
            ])
          ])
        ])
      ]),
      _createElementVNode("button", _hoisted_11, [
        (!_unref(loading))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_12
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      ])
    ], 32),
    (showPrompModal.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          onConfirm: _cache[2] || (_cache[2] = () => submitDetails()),
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (showPrompModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(Form, _normalizeProps(_guardReactiveProps(formProps)), null, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})